import numeral from 'numeral';

export default function () {
    numeral.register("locale", "en-au", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        currency: {
            symbol: "$"
        }
    })
}